/* ==========================================================================
   cmc-row-carousel
   Prev/next controls for the horizontally scrollable rows in the cmc-*
   sections (Featured Colleges). The row is a native overflow-x scroller, so
   touch swipe and keyboard scrolling work with no JS at all - this only wires
   up the arrows and keeps them enabled/disabled at the ends.
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.hasAttribute('data-cmc-carousel-ready')) return;

    var track = root.querySelector('[data-cmc-carousel-track]');
    var prev = root.querySelector('[data-cmc-carousel-prev]');
    var next = root.querySelector('[data-cmc-carousel-next]');
    // The progress bar sits outside the viewport element, next to it.
    var bar = root.parentNode && root.parentNode.querySelector('[data-cmc-carousel-bar]');
    if (!track) return;

    root.setAttribute('data-cmc-carousel-ready', '');

    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      var itemWidth = first.getBoundingClientRect().width + gap;
      // Scroll by whole items, roughly one screenful at a time.
      var perView = Math.max(1, Math.round(track.clientWidth / itemWidth));
      return itemWidth * perView;
    }

    function sync() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= maxScroll - 2;
      var noOverflow = maxScroll <= 2;

      if (prev) prev.disabled = atStart || noOverflow;
      if (next) next.disabled = atEnd || noOverflow;
      root.classList.toggle('cmc-fc--static', noOverflow);

      if (bar) {
        // Bar width mirrors how much of the row is on screen; its offset
        // mirrors how far along the row you are.
        var visibleRatio = noOverflow ? 1 : track.clientWidth / track.scrollWidth;
        var scrolledRatio = noOverflow ? 0 : track.scrollLeft / maxScroll;
        bar.style.width = (visibleRatio * 100) + '%';
        bar.style.transform = 'translateX(' + (scrolledRatio * (100 / visibleRatio - 100)) + '%)';
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-cmc-carousel]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
